<template>
  <section>
    <footer>
      <div class="footer">
        <span>Layout inspired by</span>
        <a
          href="https://mehamasum.me/"
          title="Meha Masum's website"
          target="_blank"
          >Meha Masum</a
        >
      </div>
    </footer>
  </section>
</template>

<script>
export default {
  name: "FooterSection"
};
</script>

<style></style>
